import { loadCatalogSettings } from '../../queries/rewards';

export const loadSettings = () => loadCatalogSettings();
